import { AnalyticsService } from '$lib/services/analytics/index.js';
import Cookies from 'js-cookie';

const hostname = '.abcmouse.com';
const secure = true;
const expires = 1;

const TEST_CASES = [
	{
		name: 'ct1',
		info: 'no domain, SameSite=None',
		config: {
			hostname,
			path: '/',
			httpOnly: false,
			secure,
			sameSite: 'None',
			expires,
		}
	},
	{
		name: 'ct2',
		info: '',
		config: {
			path: '/',
			httpOnly: false,
			secure,
			sameSite: 'Lax',
			expires,
		},
	},
	{
		name: 'ct3',
		info: 'no domain, SameSite=Strict',
		config: {
			path: '/',
			httpOnly: false,
			secure,
			sameSite: 'Strict',
			expires,
		},
	},
	{
		name: 'ct4',
		info: 'domain set, SameSite=None',
		config: {
			domain: hostname,
			path: '/',
			httpOnly: false,
			secure,
			sameSite: 'None',
			expires,
		},
	},
	{
		name: 'ct5',
		info: 'domain set, SameSite=Lax',
		config: {
			domain: hostname,
			path: '/',
			httpOnly: false,
			secure,
			sameSite: 'Lax',
			expires,
		},
	},
	{
		name: 'ct6',
		info: 'domain set, SameSite=Strict',
		config: {
			domain: hostname,
			path: '/',
			httpOnly: false,
			secure,
			sameSite: 'Strict',
			expires,
		},
	},
	{
		name: 'ct7',
		info: 'multiple reads',
		iterations: 5,
		config: {
			domain: hostname,
			path: '/',
			httpOnly: false,
			secure,
			sameSite: 'Lax',
			expires: 36500,
		},
	},
];

/**
 * Runs permutations of setting and reading cookies on server side
 * @param {object} context The request context
 * @returns {Promise<void>}
 */
export async function testCookiesSSR(context) {
	const errors = {};

	if (!context.cookies) {
		console.warn('context cookies not available');
		return;
	}

	for (const testCase of TEST_CASES) {
		const name = 's' + testCase.name;
		const { expires, ...baseConfig } = testCase.config;
		const config = {
			...baseConfig,
			maxAge: expires * 24 * 60 * 60,
		}

		context.cookies.set(name, name, config);

		for (let i = 0; i < testCase.iterations ?? 1; i++) {
			const val = context.cookies.get(name);
			if (val !== name) {
				errors[name] = `Read ${val} on iteration ${i}`;
				break;
			}
		}
	}

	if (Object.keys(errors).length > 0) {
		console.error(`cookie_errors: ${JSON.stringify(errors)}`);
	}
}

/**
 * Runs permutations of setting and reading cookies on client side
 * @returns {Promise<void>}
 */
export async function testCookies() {
	const errors = {};

	for (const testCase of TEST_CASES) {
		const name = 'c' + testCase.name;

		Cookies.set(name, name, testCase.config);

		for (let i = 0; i < testCase.iterations ?? 1; i++) {
			const val = Cookies.get(name);
			if (val !== name) {
				errors[name] = `Read ${val} on iteration ${i}`;
				break;
			}
		}
	}

	if (Object.keys(errors).length > 0) {
		await AnalyticsService.trackClientDebug({cookie_errors: errors});
	}
}
